import DateRangeSelector, {DateRangeSelectorProps} from "../../dateRangeSelector/DateRangeSelector";
import {FilterProps} from "../tableTypes";
import useTableData from "../tableContext/useTableData";

const DEBOUNCE_LENGTH = 1200;

interface TableDateSliderProps {
    type: string;
    min: Date;
    max: Date;
    from: Date;
    to: Date;
    filterKey: string;
}

const TableDateSlider = ({ type, min, max, from, to, filterKey }: TableDateSliderProps) => {
    const { filters, setFilters } = useTableData();
    let dateFilterTimeout: any = null;

    const onChange = (values: any[]) => {
        if(type === "date" && values.length === 2) {
            if (dateFilterTimeout) {
                clearTimeout(dateFilterTimeout);
                dateFilterTimeout = null;
            }
            dateFilterTimeout = setTimeout(() => {
                setFilters(filters.map(filter => {
                    if(filter.filterKey === filterKey && filter.type === type) {
                        const ts1 = values[0].getTime();
                        const ts2 = values[1].getTime();
                        return {...filter, from: ts1 > ts2 ? values[1] : values[0], to: ts1 > ts2 ? values[0] : values[1]}
                    } else {
                        return filter;
                    }
                }));
            }, DEBOUNCE_LENGTH);
        }
    }

    return <DateRangeSelector min={min as Date} max={max as Date} from={from} to={to} onChange={onChange} />
}

export default TableDateSlider;